


























































import moment from "moment";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import VcNavArrow from "@/components/form_components/VcNavArrow.vue";
import { storePasien } from "@/store/modules/pasien";
import DataSKDP from "@/services/DataSKDP";
import { userModule } from "@/store/modules/user";
import MasterReferensi from "@/store/modules/new/MasterReferensi";
import PasienSkdp from "@/store/modules/new/PasienSkdp";
import ReferensiUnit from "@/store/modules/new/ReferensiUnit";

@Component({
  components: { VcNavArrow }
})
export default class TglKontrolSkdpDatePicker extends Vue {
  @Prop({ required: true, default: null })
  readonly value!: string | Date;

  @Prop({ type: Boolean, default: false }) readonly outlined!: boolean;
  @Prop({ type: Boolean, default: false }) readonly dense!: boolean;
  @Prop({ default: "Tgl Kontrol" }) readonly label!: string;
  @Prop({ type: Boolean, default: false }) readonly solo!: boolean;

  // dokter (DPJP) & poli tujuan kontrol — dipakai cek kuota MJKN.
  // Default ke user login agar mundur-kompatibel bila prop tak diisi.
  @Prop({ default: () => userModule.user.id })
  readonly dpjpId!: string | number;

  @Prop({ default: () => userModule.user.unit_id })
  readonly unitId!: string | number;

  todayDate = new Date();
  maxDate = new Date().setMonth(this.todayDate.getMonth() + 3);
  loadingTglKontrol = false;
  hintTglKontrol = "";

  selectedDate = null;

  // tanggal yang MJKN-nya penuh / dokter tidak praktik (YYYY-MM-DD)
  mjknPenuhDates: Array<string> = [];

  get tglKontrol(): string | Date {
    return this.value;
  }
  set tglKontrol(val) {
    this.$emit("setValue", val);
  }

  get disabledDate() {
    const holiday = this.holidays.map(it => new Date(it.date));
    const skdp = this.upcomingSkdpList.map(it => new Date(it.tgl_kontrol));
    const skdpWarnDate = this.skdpExpandDate.map(it => new Date(it));
    const mjknPenuh = this.mjknPenuhDates.map(it => new Date(it));

    return [
      { weekdays: [1] },
      ...skdp,
      ...holiday,
      ...skdpWarnDate
      // ...mjknPenuh
    ];
  }

  get upcomingSkdpList() {
    return PasienSkdp.upcomingList;
  }

  get sessionGroupUnits() {
    return ReferensiUnit.sessGroupUnits;
  }

  get skdpExpandDate() {
    return this.expandDates(
      this.upcomingSkdpList
        .filter(
          it => !this.sessionGroupUnits.map(it => it.id).includes(it.unit_id)
        )
        .map(it => it.tgl_kontrol)
    );
  }

  get fromPage() {
    const date = this.recomDate ? new Date(this.recomDate) : null;

    if (date) {
      return {
        month: date.getMonth() + 1,
        year: date.getFullYear()
      };
    } else {
      return undefined;
    }
  }

  get datePickerAttributes() {
    let rcDt = null;
    const skdp = this.upcomingSkdpList.map(it => {
        return {
          dot: "red",
          dates: new Date(it.tgl_kontrol),
          popover: {
            label: `Kontrol di ${it.unit.nama} \n(${it.dokter.nama})`
          }
        };
      }),
      holiday = this.holidays.map(it => {
        return {
          highlight: {
            contentStyle: {
              color: "red",
              "font-weight": "bold"
            }
          },
          dates: new Date(it.date),
          popover: {
            label: it.note
          }
        };
      });

    const warning =
      this.skdpExpandDate.length > 0
        ? {
            dates: this.skdpExpandDate,
            popover: {
              label: "Jangan pilih 3 hari pra/pasca tanggal kontrol existing"
            }
          }
        : undefined;

    if (this.recomDate) {
      rcDt = {
        highlight: {
          fillMode: "outline",
          color: "blue"
        },
        dates: this.recomDate,
        popover: {
          label: "Rekomendasi Tanggal Kontrol"
        }
      };
    }

    const mjknPenuh =
      this.mjknPenuhDates.length > 0
        ? {
            dot: "gray",
            dates: this.mjknPenuhDates.map(it => new Date(it)),
            popover: {
              label: "MJKN penuh / dokter tidak praktik"
            }
          }
        : undefined;

    return [warning, ...skdp, rcDt, ...holiday, mjknPenuh];
  }

  get pasien() {
    return storePasien.identitasPasien;
  }

  selectedTglKontrol() {
    if (this.tglKontrol) {
      this.loadingTglKontrol = true;
      this.hintTglKontrol = "";
      const tglKontrol = moment(this.tglKontrol).format("YYYY-MM-DD");

      DataSKDP.getDataKontrolSkdpAlert(
        tglKontrol,
        userModule.user.unit_id,
        userModule.user.id
      )
        .then(data => {
          const dt = data["data"];

          if (dt.kuota && dt.skdp_total - dt.kuota >= -5) {
            this.hintTglKontrol = `Total pasien kontrol di tanggal ini: ${dt.skdp_total} / ${dt.kuota}`;
          }
        })
        .finally(() => {
          this.loadingTglKontrol = false;
        });
    }
  }

  mounted() {
    // this.loadKuotaMjkn();
    PasienSkdp.getUpcomingList({
      rm: this.$route.params.rm,
      tgl_kontrol_gt: moment().format("YYYY-MM-DD")
    });
  }

  @Watch("dpjpId")
  @Watch("unitId")
  onTargetChange() {
    this.loadKuotaMjkn();
  }

  loadKuotaMjkn() {
    if (!this.dpjpId || !this.unitId) {
      this.mjknPenuhDates = [];
      return;
    }

    const from = moment(this.todayDate).format("YYYY-MM-DD");
    const to = moment(this.maxDate).format("YYYY-MM-DD");

    DataSKDP.getKuotaMjknRange(this.unitId, this.dpjpId, from, to).then(data => {
      const list = data && data["data"] ? data["data"] : [];
      this.mjknPenuhDates = list
        .filter(it => it.penuh === true)
        .map(it => it.tgl);
    });
  }

  recomDate = null;

  getRecomendationKontrol() {
    //test
    if (userModule.user.unit_group_id == "27") {
      this.recomDate = this.getRecomDate();
    }
  }

  getRecomDate() {
    const pasienRegHF = this.pasien.is_reg_heart_failure;
    const now = this.todayDate;
    // const now = new Date();
    let markDayTs = new Date(new Date().setDate(now.getDate() + 30));
    let tambahanHari = 0;
    console.log("markDayTs init: " + markDayTs, markDayTs.getDay());

    // jika pasien reg hf pastikan tgl kontrol antara hari senin, rabu, jumat. dengan asumsi tgl mundur
    if (pasienRegHF || markDayTs.getDay() === 0) {
      if (![1, 3, 5].includes(markDayTs.getDay())) {
        tambahanHari = 1;
        markDayTs = new Date(
          new Date().setDate(now.getDate() + 30 + tambahanHari)
        );
      }
      console.log("markDayTs reghf: " + markDayTs);
    }

    return [
      moment(new Date(markDayTs.setDate(markDayTs.getDate()))).format(
        "YYYY-MM-DD"
      )
    ];
  }

  get holidays() {
    return MasterReferensi.holidays;
  }

  expandDates(dates: Array<string>, range = 3): Array<any> {
    const result = new Set();

    dates.forEach(dateStr => {
      const baseDate = new Date(dateStr);

      for (let offset = -range; offset <= range; offset++) {
        const d = new Date(baseDate);
        d.setDate(baseDate.getDate() + offset);

        // Format back to YYYY-MM-DD
        const formatted = d.toISOString().split("T")[0];
        // Only add if not in sourceDates
        if (!dates.includes(formatted)) {
          result.add(formatted);
        }
      }
    });

    // Convert Set → Array and sort
    return Array.from(result).sort();
  }
}
